<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">{{ $t("Addon Charges") }}</div>
    </div>

    <div class="white-wrapper my-3">
      <div class="row mb-3">
        <div class="col-md-7 col-lg-7 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected_cinema ? 'shift-up' : ''">
                {{ $tc("cinema", 1) }}
              </label>

              <multiselect
                v-model="selected_cinema"
                @select="onSelectCinema($event)"
                @remove="onRemoveCinema($event)"
                placeholder="Cinema"
                :options="Cinemas"
                label="cine_name"
                track-by="cine_id"
                :multiple="false"
                name="cine_name"
                id="cine_name"
                select-label="Select"
                deselect-label="Remove"
              ></multiselect>
            </div>
          </div>
        </div>
      </div>

      <section
        class="mb-2 w-100 section-new"
        v-for="(group, groupIndex) in GroupedAddonsArray"
        :key="groupIndex"
      >
        <div
          class="
            section-title
            mb-2
            d-flex
            justify-content-between
            section-collapse-box
          "
          @click="toggleCollapses(`group${groupIndex}`)"
          style="padding:6px;align-items:center;"
        >
          <span class="fs">
            {{ group[0] }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse :id="`group${groupIndex}`" class="mt-2">
          <div class="px-3 border br-10 mx-auto">
            <div
              class="row pt-3 borderDivider"
              v-for="(charges, chargeIndex) in group[1]"
              :key="chargeIndex"
            >
              <div class="d-flex align-items-center col-2">
                <div class="input-material">
                  <input
                    placeholder="."
                    :disabled="checkDisableName(charges)"
                    type="text"
                    @change="onChangeTrack(groupIndex, chargeIndex)"
                    v-model="charges.addons_name"
                  />
                  <label>{{ "Charge Name" }}</label>
                </div>
              </div>
              <div class="d-flex align-items-center col-1">
                <div class="input-material">
                  <input
                    style="text-align:right;"
                    placeholder="."
                    type="number"
                    v-model="charges.add_ons_price"
                    @input="handleChangePrice(groupIndex, chargeIndex)"
                  />
                  <label>{{ "Price" }}</label>
                </div>
              </div>

              <div class="d-flex align-items-center mx-4">
                <label class="mr-2">{{ $t("Tax Applicable") }}</label>
                <b-form-checkbox
                  class="j-checkbox mb-1 pb-0"
                  name="check-button"
                  :disabled="charges.isDiscount"
                  @change="
                    onSwitchTaxApplicable(
                      $event,
                      charges,
                      groupIndex,
                      chargeIndex
                    )
                  "
                  v-model="charges.isChargeTypeApplicable"
                ></b-form-checkbox>
              </div>

              <div class="d-flex align-items-center mx-4" v-if="charges.type_id != 6">
                <label class="mr-2">Is Percentage</label>
                <b-form-checkbox
                  :id="`is_percentage${groupIndex}${chargeIndex}`"
                  v-model="charges.is_percentage"
                  unchecked-value="N"
                  value="Y"
                  @change="onChangeTrack(groupIndex, chargeIndex)"
                  class="j-checkbox mb-1 pb-0"
                  name="check-button"
                ></b-form-checkbox>
              </div>

              <div
                class="d-flex align-items-center mx-4"
                v-if="charges.type_id == 0 && false"
              >
                <label class="mr-2">Is Discount</label>
                <b-form-checkbox
                  :id="`is_discount${groupIndex}${chargeIndex}`"
                  v-model="charges.isDiscount"
                  @change="
                    onSwithcDiscount($event, charges, groupIndex, chargeIndex)
                  "
                  class="j-checkbox mb-1 pb-0"
                  name="check-button"
                ></b-form-checkbox>
              </div>

              <div class="d-flex align-items-center mx-4">
                <label class="mr-2">{{ $t("active") }}</label>
                <b-form-checkbox
                  class="j-checkbox mb-1 pb-0"
                  name="check-button"
                  unchecked-value="N"
                  value="Y"
                  v-model="charges.is_addons_active"
                  @change="onChangeTrack(groupIndex, chargeIndex)"
                ></b-form-checkbox>
              </div>

              <div class="d-flex align-items-center float-right col-1">
                <div class="right_align_absolute d-flex align-items-center">
                  <div class="">
                    <button
                      v-if="charges.type_id == 0 && charges.allowEdit && $can('update', 'Add on Charges')"
                      @click.prevent.stop="
                        removeCustomCharge(groupIndex, chargeIndex)
                      "
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                  <div
                    v-if="checkChanges(groupIndex, chargeIndex)"
                    class="icon-save-btn blue-icon mx-1 btn float-right"
                    @click="singleSubmit(charges, groupIndex, chargeIndex)"
                    :title="'Save Charges'"
                  ></div>
                  <span
                    class="icon-collapse-up blue-icon mx-1 btn float-right"
                    v-if="charges.moreSettings"
                    @click="onToggleMoreSettings(charges)"
                  ></span>
                  <span
                    class="icon-collapse blue-icon mx-1 btn float-right"
                    v-if="!charges.moreSettings"
                    @click="onToggleMoreSettings(charges)"
                  ></span>
                </div>
              </div>

              <div class="col-12 py-2 px-2">
                <b-collapse
                  v-model="charges.isChargeTypeApplicable"
                  class="pt-2 px-2"
                >
                  <div class="row justify-content-start">
                    <div class="col-md-3 mb-1">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            charges.selected_chargeSettings ? 'shift-up' : ''
                          "
                        >
                          Charge Setting
                        </label>

                        <multiselect
                          v-model="charges.selected_chargeSettings"
                          @select="
                            onSelectChargeSettings(
                              $event,
                              charges,
                              groupIndex,
                              chargeIndex
                            )
                          "
                          placeholder=""
                          :options="chargeSettings"
                          label="pas_charge_setting_name"
                          track-by="pas_id"
                          :multiple="false"
                          name="pas_charge_setting_name"
                          id="pas_charge_setting_name"
                          select-label="Select"
                          deselect-label="Remove"
                        ></multiselect>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center col-2"
                      v-if="charges.is_percentage == 'N'"
                      v-for="(tax,
                      taxIndex) in charges.charge_type_array_addons"
                      :key="taxIndex"
                    >
                      <div class="input-material">
                        <input
                          placeholder="."
                          type="text"
                          disabled
                          v-model="tax.cinemacharges"
                        />
                        <label
                          >{{ tax.charge_name }} {{ tax.charge_value
                          }}{{ tax.pas_is_percentage == "Y" ? "%" : "" }}</label
                        >
                      </div>
                    </div>
                  </div>
                  <p
                    class="text-muted fs-12 mt-1 d-flex justify-content-start mb-0"
                  >
                    *All Taxes are inclusive
                  </p>
                </b-collapse>
                <b-collapse v-model="charges.isDiscount" class="pt-2 px-2">
                  <div class="row">
                    <div class="d-flex align-items-center col-2">
                      <div class="input-material">
                        <input
                          style="text-align:right;"
                          placeholder="."
                          type="number"
                          v-model="charges.min_seats"
                          v-on:keydown="
                            e => {
                              if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                                e.preventDefault();
                              }
                            }
                          "
                        />
                        <label>{{ "Min. Seats" }}</label>
                      </div>
                    </div>
                  </div>
                </b-collapse>
                <b-collapse v-model="charges.moreSettings" class="pt-2 px-2">
                  <div class="row">
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between

                      "
                      v-if="checkClientName() && showCheckbox(charges)"
                    >
                      <b-form-checkbox
                        :id="
                          `is_additional_price_on_ticket${groupIndex}${chargeIndex}`
                        "
                        v-model="charges.is_additional_price_on_ticket"
                        unchecked-value="N"
                        value="Y"
                        class="j-checkbox mx-3 mb-3"
                        @change="onChangeTrack(groupIndex, chargeIndex)"
                      >
                        <div class="text-capitalize">
                          Additional Price on Ticket
                        </div>
                      </b-form-checkbox>
                    </div>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between

                      "
                      v-if="showCheckbox(charges)"
                    >
                      <b-form-checkbox
                        :id="`is_shown_on_ticket${groupIndex}${chargeIndex}`"
                        v-model="charges.is_shown_on_ticket"
                        unchecked-value="N"
                        value="Y"
                        class="j-checkbox mx-3 mb-3"
                        @change="onChangeTrack(groupIndex, chargeIndex)"
                      >
                        <div class="text-capitalize">Show On Ticket</div>
                      </b-form-checkbox>
                    </div>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between

                      "
                       v-if="showCheckbox(charges)"
                    >
                      <b-form-checkbox
                        :id="`is_compulsory_add_ons${groupIndex}${chargeIndex}`"
                        v-model="charges.is_compulsory_add_ons"
                        unchecked-value="N"
                        value="Y"
                        class="j-checkbox mx-3 mb-3"
                        @change="onChangeTrack(groupIndex, chargeIndex)"
                      >
                        <div class="text-capitalize">Auto Attach</div>
                      </b-form-checkbox>
                    </div>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between

                      "
                       v-if="showCheckbox(charges)"
                    >
                      <b-form-checkbox
                        :id="`is_share_distributor${groupIndex}${chargeIndex}`"
                        v-model="charges.is_share_distributor"
                        unchecked-value="N"
                        value="Y"
                        class="j-checkbox mx-3 mb-3"
                        @change="onChangeTrack(groupIndex, chargeIndex)"
                      >
                        <div class="text-capitalize">
                          Share With Distributor
                        </div>
                      </b-form-checkbox>
                    </div>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between

                      "
                       v-if="showCheckbox(charges)"
                    >
                      <b-form-checkbox
                        :id="`is_for_pos${groupIndex}${chargeIndex}`"
                        v-model="charges.is_for_pos"
                        unchecked-value="N"
                        value="Y"
                        class="j-checkbox mx-3 mb-3"
                        @change="onChangeTrack(groupIndex, chargeIndex)"
                      >
                        <div class="text-capitalize">Box Office</div>
                      </b-form-checkbox>
                    </div>
                    <div
                      v-if="charges.type_id == 0 && showCheckbox(charges)"
                      class="
                        d-flex
                        align-items-center
                        justify-content-between

                      "
                    >
                      <b-form-checkbox
                        :id="`is_for_fnb${groupIndex}${chargeIndex}`"
                        v-model="charges.is_for_fnb"
                        unchecked-value="N"
                        value="Y"
                        v-if="false"
                        class="j-checkbox mx-3 mb-3"
                        @change="onChangeTrack(groupIndex, chargeIndex)"
                      >
                        <div class="text-capitalize">Concession</div>
                      </b-form-checkbox>
                    </div>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between

                      "
                      v-if="showCheckbox(charges)"
                    >
                      <b-form-checkbox
                        :id="`is_for_online${groupIndex}${chargeIndex}`"
                        v-model="charges.is_for_online"
                        unchecked-value="N"
                        value="Y"
                        class="j-checkbox mx-3 mb-3"
                        @change="onChangeTrack(groupIndex, chargeIndex)"
                      >
                        <div class="text-capitalize">Online</div>
                      </b-form-checkbox>
                    </div>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between

                      "
                      v-if="showCheckbox(charges)"
                    >
                      <b-form-checkbox
                        :id="`is_on_gross${groupIndex}${chargeIndex}`"
                        v-model="charges.is_on_gross"
                        v-if="false"
                        unchecked-value="N"
                        value="Y"
                        class="j-checkbox mx-3 mb-3"
                        @change="onChangeTrack(groupIndex, chargeIndex)"
                      >
                        <div class="text-capitalize">On Gross Amount</div>
                      </b-form-checkbox>
                    </div>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between

                      "
                      v-if="showCheckbox(charges)"
                    >
                      <b-form-checkbox
                        :id="`is_on_per_ticket${groupIndex}${chargeIndex}`"
                        v-model="charges.is_on_per_ticket"
                        unchecked-value="N"
                        value="Y"
                        class="j-checkbox mx-3 mb-3"
                        @change="onChangeTrack(groupIndex, chargeIndex)"
                      >
                        <div class="text-capitalize">Per ticket</div>
                      </b-form-checkbox>
                    </div>
                  </div>
                  <template v-if="showErpColumns">
                    <div class="row">
                    <div class="col-lg-2 col-xl-2 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          style="text-align: right"
                          placeholder="."
                          type="text"
                          v-model="charges.report_code"
                          name="report_code"
                          id="report_code"
                          v-validate=""
                          @change="onChangeTrack(groupIndex, chargeIndex)"
                        />
                        <label>{{ "Report Code" }}</label>
                      </div>
                    </div>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="charges.gl_account"
                            name="gl_account"
                            id="gl_account"
                            v-validate=""
                            @change="onChangeTrack(groupIndex, chargeIndex)"
                          />
                          <label>{{ "GL Account" }}</label>
                        </div>
                      </div>
                    </div>

                      <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="charges.gl_desc"
                            name="gl_desc"
                            id="gl_desc"
                            v-validate=""
                            @change="onChangeTrack(groupIndex, chargeIndex)"
                          />
                          <label>{{ "GL Desc." }}</label>
                        </div>
                      </div>
                    </div>
                    </div>
                  </template>
                </b-collapse>
              </div>
            </div>
            <div
              v-if="
                (group[1].length > 0 && group[1][0].type_id == 0) ||
                  group[1].length == 0
              "
              :class="group[1].length > 0 ? 'mt-5' : ''"
              class="row d-flex align-items-center justify-content-center position-relative"
            >
              <button
                @click.prevent.stop="addCustomCharge(groupIndex)"
                class="btn-transparent add-more-button"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </b-collapse>
      </section>

      <section
        class="
          mb-5
          w-100
          d-flex
          align-item-center
          justify-content-center
          my-auto
        "
        style="min-height: 100px; border: 1px solid lightgray"
        v-if="GroupedAddonsArray.length == 0"
      >
        <p
          class="d-flex align-item-center justify-content-center my-auto fs-16"
        >
          No Add Ons Charges Found.
        </p>
      </section>

      <div class="text-center" v-if="GroupedAddonsArray.length > 0">
        <button @click.prevent.stop="SubmitAll(null)" class="btn-blue">
          Save All
        </button>
        <button @click.prevent.stop="SubmitAll(1)" class="btn-blue">
          Save & Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import { mapGetters } from "vuex";
import _ from "lodash";
import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

export default {
  data() {
    return {
      chargeSettings: [],
      GroupedAddonsArray: [],
      selected_cinema: "",
      CinemaId: null,
      Cinemas: [],
      customChargeObj: {},
      totalTaxPercentage: 0,
      finalSubmitArray: [],
      tempGroupIndex: null,
      tempChargeIndex: null,
      changeTrackArray: [],
      typeCLose: null
    };
  },
  computed: {
     showErpColumns() {
      return this.$store.getters.SHOW_ERP_GL_FIELDS == 'Y' ? true : false;
    },
    qfx_tax_structure() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.qfx_tax_structure);
    },
    mif_tax_calculation() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.mif_tax_calculation);
    },
     fractionDigits() {
      let fracDigit = 3;
      if (this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis_combo)) {
        fracDigit = 2
      } else {
        fracDigit = 3;
      }
      return fracDigit;
    },
  },
  watch: {},
  beforeMount() {
    this.getCinemasList();
  },
  mounted() {},
  methods: {
    checkClientName() {
      console.log(CLIENT_NAME.EMPIRE, this.CLIENT_SETUP_NAME);
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME && false;
    },
    showCheckbox(charge) {
      if(charge.type_id == 6) {
        return false
      } else {
        return true
      }
    },
    onSwithcDiscount(event, charges, groupIndex, chargeIndex) {
      console.log("onSwithcDiscount Event", event);
      if (event) {
        charges.isChargeTypeApplicable = false;
        charges.is_charge_type = "N";
      }
      charges.is_discount = event ? "Y" : "N";
      this.onChangeTrack(groupIndex, chargeIndex);
    },
    checkChanges(groupIndex, chargeIndex) {
      if (this.GroupedAddonsArray[groupIndex][1][chargeIndex].isChanged) {
        return true;
      } else {
        return false;
      }
    },
    onChangeTrack(groupIndex, chargeIndex) {
      this.GroupedAddonsArray[groupIndex][1][chargeIndex].isChanged = true;

      console.log(this.GroupedAddonsArray[groupIndex][1][chargeIndex]);
      setTimeout(() => {
        if (
          this.GroupedAddonsArray[groupIndex][1][chargeIndex].is_percentage ==
          "Y"
        ) {
          this.GroupedAddonsArray[groupIndex][1][chargeIndex].is_on_per_ticket =
            "N";
        }

        if (
          this.GroupedAddonsArray[groupIndex][1][chargeIndex]
            .is_additional_price_on_ticket == "Y" &&
          this.GroupedAddonsArray[groupIndex][1][chargeIndex].is_percentage ==
            "N"
        ) {
          this.GroupedAddonsArray[groupIndex][1][chargeIndex].is_on_per_ticket =
            "Y";
        }
      });
    },
    checkDisableName(charges) {
      if (charges.hasOwnProperty("allowEdit") && charges.allowEdit) {
        return false;
      } else {
        return true;
      }
    },
    removeCustomCharge(groupIndex, chargeIndex) {
      this.GroupedAddonsArray[groupIndex][1].splice(chargeIndex, 1);
    },
    addCustomCharge(groupIndex) {
      if (Object.keys(this.customChargeObj).length !== 0) {
        let newObj = {
          ...this.customChargeObj,
          allowEdit: true,
          isChargeTypeApplicable: false,
          isDiscount: false,
          moreSettings: false,
          net_price: 0,
          isChanged: true,
          selected_chargeSettings: "",
          ct_array: []
        };
        this.GroupedAddonsArray[groupIndex][1].push(newObj);
      } else {
        this.$toasted.show("Error: Something Went Wrong!");
      }
    },
    checkValidation() {
      let count = 0;
      let errorMsg = "";
      this.finalSubmitArray.map(z => {
        if (isNaN(z.add_ons_price)) {
          count++;
          errorMsg = `Please Enter Valid Price!`;
        } else if (!z.addons_name) {
          count++;
          errorMsg = `Please Enter Add On Charge Name`;
        } else if (z.isChargeTypeApplicable && !z.charge_type_id) {
          count++;
          errorMsg = `Please Select Charge Type For ${z.addons_name}`;
        } else if (
          z.isChargeTypeApplicable &&
          z.charge_type_array_addons.length == 0
        ) {
          count++;
          errorMsg = `Please Select Charge Type For ${z.addons_name}`;
        } else if (z.isDiscount && z.min_seats == 0) {
          count++;
          errorMsg = `Please Enter Min seats for ${z.addons_name}`;
        } else if (z.isDiscount && isNaN(z.min_seats)) {
          count++;
          errorMsg = `Please Enter Valid Min seats for ${z.addons_name}`;
        }
      });

      if (count > 0) {
        this.$toasted.show(errorMsg);
        return false;
      } else {
        return true;
      }
    },
    handleSubmit(singleSubmit = false, submitObj) {
      if (this.cinemaId) {
        this.finalSubmitArray.forEach(x => {
          x.cinema_id = this.cinemaId;
        });
        if (this.checkValidation()) {
          let loader = this.$loading.show();
          let payload = {
            add_ons_array: this.finalSubmitArray,
            cinema_id:this.cinemaId
          };
          MasterService.UpdateAddonsCharge(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status) {
                if (this.typeCLose) {
                  this.$router.push({
                    path: "/"
                  });
                  return;
                }
                if (singleSubmit) {
                  if (
                    data.hasOwnProperty("returnObj") &&
                    data.returnObj.length > 0
                  ) {
                    let tempObj = {
                      ...data.returnObj[0],
                      isChargeTypeApplicable:
                        data.returnObj[0].is_charge_type == "Y" ? true : false,
                      isDiscount:
                        data.returnObj[0].is_discount == "Y" ? true : false,
                      moreSettings: false,
                      net_price: 0,
                      isChanged: false,
                      allowEdit: false,
                      selected_chargeSettings: this.chargeSettings.find(
                        z => z.pas_id == data.returnObj[0].charge_type_id
                      ),
                      ct_array: []
                    };

                    Object.assign(
                      this.GroupedAddonsArray[this.tempGroupIndex][1][
                        this.tempChargeIndex
                      ],
                      tempObj
                    );

                    this.$forceUpdate();
                  } else {
                    this.getAddonsCharges();
                  }
                } else {
                  this.tempGroupIndex = null;
                  this.tempChargeIndex = null;
                  this.getAddonsCharges();
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(err => {
              console.log("Error:", err);
            })
            .finally(() => {
              loader.hide();
            });
        } else {
          console.log("Validation Failed");
        }
      } else {
        this.$toasted.show("Please Select Cinema");
        console.log("Please Select Cinema");
      }
    },
    SubmitAll(type) {
      this.typeCLose = type;
      this.finalSubmitArray = [];
      let flatedArray = _.flatMap(_.fromPairs(this.GroupedAddonsArray));
      console.log("flatedArray", flatedArray);
      this.finalSubmitArray = _.cloneDeep(flatedArray);
      this.handleSubmit();
      console.log("FinalSubmitArray", this.GroupedAddonsArray);
    },
    singleSubmit(submitObj, groupIndex, chargeIndex) {
      this.tempGroupIndex = groupIndex;
      this.tempChargeIndex = chargeIndex;
      this.finalSubmitArray = [];
      this.finalSubmitArray.push(submitObj);
      this.handleSubmit(true, submitObj);
      console.log("Singal Submit", submitObj);
    },
    onRemoveCinema(event) {
      console.log("Event onRemoveCinema", event);
      this.GroupedAddonsArray = [];
    },
    onSwitchTaxApplicable(event, charges, groupIndex, chargeIndex) {
      console.log("onSwitchTaxApplicable Event", event, charges);
      if (!event) {
        charges.charge_type_array_addons = [];
        charges.selected_chargeSettings = "";
        charges.charge_type_id = 0;
      }
      charges.is_charge_type = event ? "Y" : "N";
      this.onChangeTrack(groupIndex, chargeIndex);
    },
    onToggleMoreSettings(charges) {
      charges.moreSettings = !charges.moreSettings;
    },
    onSelectChargeSettings(event, charges, groupIndex, chargeIndex) {
      console.log(" onSelectChargeSettings event", event, charges);
      charges.charge_type_id = event.pas_id;
      charges.charge_type_array_addons = [];
      charges.ct_array = [];
      charges.selected_chargeSettings = event.pas_charge_setting_name;
      this.onChangeTrack(groupIndex, chargeIndex);
      this.getCinemaCharges(
        this.cinemaId,
        event.pas_charge_setting_name,
        groupIndex,
        chargeIndex
      );
    },
    toggleCollapses(id) {
      this.$root.$emit("bv::toggle::collapse", id);
    },
    onSelectCinema(cinema) {
      this.cinemaId = cinema.cine_id;
      this.selected_cinema = cinema;

      this.getAddonsCharges();
      this.getChargeSettingName(cinema.cine_id);
    },
    getAddonsCharges() {
      if (!this.cinemaId) {
        return this.$toasted.show("Please Select Cinema");
      } else {
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.cinemaId
        };

        MasterService.getAllAddonsCharges(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status) {
              console.log("data TEST @@", data);

              data.Records.forEach(x => {
                x["isChargeTypeApplicable"] =
                  x.is_charge_type == "Y" ? true : false;
                x["isDiscount"] = x.is_discount == "Y" ? true : false;
                x["moreSettings"] = false;
                x["net_price"] = 0;
                x["isChanged"] = false;
                x["selected_chargeSettings"] = this.chargeSettings.find(
                  z => z.pas_id == x.charge_type_id
                );
                x["ct_array"] = [];
              });

              if (
                data.hasOwnProperty("newAdditionTax") &&
                data.newAdditionTax
              ) {
                this.customChargeObj = _.cloneDeep(data.newAdditionTax);
              }

              this.GroupedAddonsArray = _.toPairs(
                _.groupBy(data.Records, "type_name")
              );

              let checkCustomChargeExists = data.Records.filter(
                x => x.type_id == 0
              );
              let tempArray = [];

              if (
                checkCustomChargeExists &&
                checkCustomChargeExists.length == 0
              ) {
                tempArray = ["Custom Addons", []];
                this.GroupedAddonsArray.push(tempArray);
              }

              console.log("TEST Group", this.GroupedAddonsArray);
            } else {
              this.$toasted.show(
                data.message || "Error: Something Went Wrong!"
              );
            }
          })
          .catch(err => {
            console.log("Error: TEst@", err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    handleChangePrice(groupIndex, chargeIndex) {
      if (this.GroupedAddonsArray[groupIndex][1][chargeIndex].add_ons_price) {
        this.cinemaChargesCalculation(groupIndex, chargeIndex);
      }

      this.onChangeTrack(groupIndex, chargeIndex);
      console.log(
        "this.GroupedAddonsArray[groupIndex][1][chargeIndex]",
        this.GroupedAddonsArray[groupIndex][1][chargeIndex]
      );
    },
    getChargeSettingName: function(id) {
      console.log("Hittings charge API", id);
      this.chargeSettings = [];
      CinemasService.GetCinemaSettingNameByCinemaId({ id })
        .then(async response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.chargeSettings = data.Records;
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Error :", error);
        });
    },
    getFloat(val = '0', fractionDigits = this.fractionDigits) {
      let parsed = parseFloat(String(val) || '0') || parseFloat('0')
      return (+parseFloat(parsed.toFixed(fractionDigits)))
    },
    cinemaChargesCalculation: function(groupIndex, chargeIndex) {
      if (
        String(
          this.GroupedAddonsArray[groupIndex][1][chargeIndex].add_ons_price
        ).length > 0 &&
        this.GroupedAddonsArray[groupIndex][1][chargeIndex].is_percentage == "N"
      ) {
        this.GroupedAddonsArray[groupIndex][1][
          chargeIndex
        ].net_price = parseFloat(
          this.GroupedAddonsArray[groupIndex][1][chargeIndex].add_ons_price
        );
        if (this.qfx_tax_structure) {
          let grosss = this.getSafe(() => this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(x => x), [])
            .filter(g => String(g.ct_name).toUpperCase().includes('VAT'))
            .filter(g => g.pas_is_percentage === 'Y')

          let nets = this.getSafe(() => this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(x => x), [])
            .filter(g => !String(g.ct_name).toUpperCase().includes('VAT'))
            .filter(g => g.pas_is_percentage === 'Y')

          let misc_products = this.getSafe(() => this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(x => x), [])
            .filter(g => g.pas_is_percentage === 'N')
            .filter(g => !String(g.ct_name).toUpperCase().includes('VAT'))

          console.log({ nets, grosss, misc_products, taxes: this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(x => x) })

          let vat_pas_id = this.getSafe(() => grosss[0].pas_id)
          let vat_percent = this.getFloat(this.getSafe(() => grosss[0].pas_charge_value, 0), 2)

          let net_1_pas_id = this.getSafe(() => nets[0].pas_id)
          let net_1_percent = this.getFloat(this.getSafe(() => nets[0].pas_charge_value, '0'), 2)

          let net_2_pas_id = this.getSafe(() => nets[1].pas_id)
          let net_2_percent = this.getFloat(this.getSafe(() => nets[1].pas_charge_value, '0'), 2)

          let misc_product_rate_pas_id = this.getSafe(() => misc_products[0].pas_id)
          let misc_product_rate_1 = this.getFloat(this.getSafe(() => misc_products[0].pas_charge_value, '0'), 2)
          let misc_rate_exist = misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0
          let amount = this.getFloat(this.GroupedAddonsArray[groupIndex][1][chargeIndex].add_ons_price || 0);

          /** Gross */
          let G = amount
          /** Taxable/Net */
          let E = this.getFloat(amount / (1 + (vat_percent / 100)))
          /** VAT */
          let F = this.getFloat((vat_percent / 100) * E)
          /** 3D/Prod */
          let B = this.getFloat(misc_product_rate_1 / (1 + (vat_percent / 100)))
          /** Ticket Rate */
          let totalPerCentOfA = (1 + ((net_1_percent + net_2_percent) / 100))
          let A = this.getFloat((E - B) / (totalPerCentOfA))
          /** Film Dev Tax */
          let C = this.getFloat((net_1_percent / 100) * A)
          /** State & Local Ent Tax */
          let D = this.getFloat((net_2_percent / 100) * A)

          console.log({
            amount,
            vat_percent,
            net_1_percent,
            net_2_percent,
            totalPerCentOfA,
            misc_rate_exist,
            misc_product_rate_1
          })
          console.log({
            Gross: G,
            Net: E,
            VAT: F,
            FDT: C,
            SLE: D,
            '3D': B,
            'TicketRate': A,
            'ProductRate': B,
          })

          let NET_AMT = E
          let BASE_RATE = A
          let NET_1_AMT = C
          let NET_2_AMT = D
          let NET_3_AMT = B // misc_product_rate_1
          let VAT_AMT = F
          let Gross = G

          this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map((x, i) => {
            if (x.pas_id == vat_pas_id) {
              x.cinemacharges = (VAT_AMT)
            }
            if (x.pas_id == net_1_pas_id) {
              x['cinemacharges'] = (NET_1_AMT)
            }
            if (x.pas_id == net_2_pas_id) {
              x['cinemacharges'] = (NET_2_AMT)
            }
            if (x.pas_id == misc_product_rate_pas_id) {
              x['cinemacharges'] = (NET_3_AMT)
            }

            this.GroupedAddonsArray[groupIndex][1][
                  chargeIndex
                ].charge_type_array_addons[i].cinemacharges = x.cinemacharges;
          })

          this.GroupedAddonsArray[groupIndex][1][
            chargeIndex
          ].net_price = this.getFloat(BASE_RATE + NET_3_AMT)

          

          this.$forceUpdate();
        } else if(this.mif_tax_calculation) {

          let grosss = this.getSafe(() => this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(x => x), [])
            .filter(g => String(g.ct_name).toUpperCase().includes('VAT'))
            .filter(g => g.pas_is_percentage === 'Y')

          let nets = this.getSafe(() => this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(x => x), [])
            .filter(g => !String(g.ct_name).toUpperCase().includes('VAT'))
            .filter(g => g.pas_is_percentage === 'Y')

          let misc_products = this.getSafe(() => this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(x => x), [])
            .filter(g => g.pas_is_percentage === 'N')
            .filter(g => !String(g.ct_name).toUpperCase().includes('VAT'))

          console.log({ nets, grosss, misc_products, taxes: this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(x => x) })

          let vat_pas_id = this.getSafe(() => grosss[0].pas_id)
          let vat_percent = this.getFloat(this.getSafe(() => grosss[0].pas_charge_value, 0), 2)

          let net_1_pas_id = this.getSafe(() => nets[0].pas_id)
          let net_1_percent = this.getFloat(this.getSafe(() => nets[0].pas_charge_value, '0'), 2)

          let net_2_pas_id = this.getSafe(() => nets[1].pas_id)
          let net_2_percent = this.getFloat(this.getSafe(() => nets[1].pas_charge_value, '0'), 2)

          let misc_product_rate_pas_id = this.getSafe(() => misc_products[0].pas_id)
          let misc_product_rate_1 = this.getFloat(this.getSafe(() => misc_products[0].pas_charge_value, '0'), 2)
          let misc_rate_exist = misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0

          let all_mis_product_sum = 0;
          if (misc_products && misc_products.length) {
            all_mis_product_sum =
              this.getFloat(
                misc_products.reduce(
                  (acc, { pas_charge_value }) =>
                    acc + parseFloat(pas_charge_value),
                  0
                ),
                3
              ) || 0;
          }

          let amount = this.getFloat(this.GroupedAddonsArray[groupIndex][1][chargeIndex].add_ons_price || 0);

          /** Gross */
          let G = amount
          /** Taxable/Net */
          let E = this.getFloat(amount / (1 + (vat_percent / 100)))
          /** VAT */
          let F = this.getFloat((vat_percent / 100) * E)
          /** 3D/Prod */
          let B = this.getFloat(all_mis_product_sum || 0);
          /** Ticket Rate */
          let totalPerCentOfA = (1 + ((net_1_percent + net_2_percent) / 100))
          let A = this.getFloat((E - B) / (totalPerCentOfA))
          /** Film Dev Tax */
          let C = this.getFloat((net_1_percent / 100) * A)
          /** State & Local Ent Tax */
          let D = this.getFloat((net_2_percent / 100) * A)

          console.log({
            amount,
            vat_percent,
            net_1_percent,
            net_2_percent,
            totalPerCentOfA,
            misc_rate_exist,
            misc_product_rate_1
          })
          console.log({
            Gross: G,
            Net: E,
            VAT: F,
            FDT: C,
            SLE: D,
            '3D': B,
            'TicketRate': A,
            'ProductRate': B,
          })

          let NET_AMT = E
          let BASE_RATE = A
          let NET_1_AMT = C
          let NET_2_AMT = D
          let NET_3_AMT = B // misc_product_rate_1
          let VAT_AMT = F
          let Gross = G

          this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map((x, i) => {
            if (x.pas_id == vat_pas_id) {
              x.cinemacharges = this.getFloat(VAT_AMT, 2)
            }
            if (x.pas_id == net_1_pas_id) {
              x['cinemacharges'] = this.getFloat(NET_1_AMT, 2)
            }
            if (x.pas_id == net_2_pas_id) {
              x['cinemacharges'] = this.getFloat(NET_2_AMT, 2)
            }
            if (x.pas_is_percentage == "N") {
            let findIndex = misc_products.findIndex(
              (mis) => mis.pas_id == x.pas_id
            );

            if (findIndex > -1) {
               x['cinemacharges'] = parseFloat(
                misc_products[findIndex]["pas_charge_value"]
              ).toFixed(2);
            }
          }

            this.GroupedAddonsArray[groupIndex][1][
                  chargeIndex
                ].charge_type_array_addons[i].cinemacharges = x.cinemacharges;
          })

          // this.GroupedAddonsArray[groupIndex][1][
          //   chargeIndex
          // ].net_price = this.getFloat(BASE_RATE + NET_3_AMT)

          this.GroupedAddonsArray[groupIndex][1][
            chargeIndex
          ].net_price = this.getFloat(BASE_RATE)

          this.$forceUpdate();
        } else {
          if (
            this.GroupedAddonsArray[groupIndex][1][chargeIndex].is_inclusive ==
            "N"
          ) {
            //if percentage, create the cinema charge on top of the initial ratecard input
            this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(
              (x, index) => {
                if (x.pas_is_percentage === "Y") {
                  x.cinemacharges = parseFloat(
                    (parseFloat(
                      this.GroupedAddonsArray[groupIndex][1][chargeIndex]
                        .add_ons_price
                    ) *
                      parseFloat(x.pas_charge_value)) /
                    100
                  ).toFixed(this.MIN_FRACTION_DIGITS);
                }
                this.GroupedAddonsArray[groupIndex][1][
                  chargeIndex
                ].charge_type_array_addons[index].cinemacharges = x.cinemacharges;

                if (x.pas_is_rebate == "N") {
                  x.extraChargesSum = parseFloat(
                    parseFloat(x.extraChargesSum) + parseFloat(x.cinemacharges)
                  ).toFixed(this.MIN_FRACTION_DIGITS);
                } else {
                  x.extraChargesSum = parseFloat(
                    parseFloat(x.extraChargesSum) - parseFloat(x.cinemacharges)
                  ).toFixed(this.MIN_FRACTION_DIGITS);
                }
                x.extraChargesSum = parseFloat(
                  parseFloat(x.extraChargesSum) + parseFloat(x.cinemacharges)
                ).toFixed(this.MIN_FRACTION_DIGITS);

                //add the cinema charge to the net amount to create total
                this.calculateNetAmount(x, "Plus");
              }
            );
          } else if (
            this.GroupedAddonsArray[groupIndex][1][chargeIndex].is_inclusive ==
            "Y"
          ) {
            var t = this.GroupedAddonsArray[groupIndex][1][chargeIndex]
              .add_ons_price,
              grossAmount = this.GroupedAddonsArray[groupIndex][1][chargeIndex]
                .add_ons_price;
            var k = 0,
              sumFixedTaxable = 0,
              w = 0,
              sumFixedRebate = 0,
              v = 0,
              sumFixedTax = 0,
              y = 0,
              sumPercentageTaxable = 0,
              z = 0,
              sumPercentageRebate = 0,
              a = 0,
              sumPercentageTax = 0;

            this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(
              (x, index) => {
                if (
                  x.pas_is_percentage === "N" &&
                  x.pas_is_taxable === "Y" &&
                  x.pas_is_rebate == "N"
                ) {
                  k += x.pas_charge_value;
                } else if (
                  x.pas_is_percentage === "N" &&
                  x.pas_is_rebate == "Y"
                ) {
                  //rebate does not have tax
                  w += x.pas_charge_value;
                } else if (
                  x.pas_is_percentage === "N" &&
                  x.pas_is_taxable === "N" &&
                  x.pas_is_rebate == "N"
                ) {
                  v += x.pas_charge_value;
                } else if (
                  x.pas_is_percentage === "Y" &&
                  x.pas_is_taxable === "Y" &&
                  x.pas_is_rebate == "N"
                ) {
                  y += x.pas_charge_value;
                } else if (
                  x.pas_is_percentage === "Y" &&
                  x.pas_is_rebate == "Y"
                ) {
                  //rebate does not have tax
                  z += x.pas_charge_value;
                } else if (
                  x.pas_is_percentage === "Y" &&
                  x.pas_is_taxable === "N" &&
                  x.pas_is_rebate == "N"
                ) {
                  a += x.pas_charge_value;
                }
              }
            );
            sumFixedTaxable = k;
            sumFixedRebate = w;
            sumFixedTax = v;
            sumPercentageTaxable = y;
            sumPercentageRebate = z;
            sumPercentageTax = a;

            this.totalTaxPercentage = sumPercentageTax;

            this.GroupedAddonsArray[groupIndex][1][
              chargeIndex
            ].net_price = parseFloat(
              (10000 * t +
                10000 * w -
                10000 * v +
                100 * k * z -
                100 * k * a -
                10000 * k) /
              (10000 + y * a - z * y + 100 * y + 100 * a - 100 * z)
            ).toFixed(3);
            w = 0;
            z = 0;
            let netAmountWithoutRebate =
              (10000 * t +
                10000 * w -
                10000 * v +
                100 * k * z -
                100 * k * a -
                10000 * k) /
              (10000 + y * a - z * y + 100 * y + 100 * a - 100 * z);
            console.log("test", netAmountWithoutRebate);
            // console.log(netAmount)
            console.log(
              "1 this.ratecard.rc_net_amount",
              this.GroupedAddonsArray[groupIndex][1][chargeIndex].net_price
            );

            this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array.map(
              (x, index) => {
                if (
                  x.pas_is_percentage === "N" &&
                  x.pas_is_taxable === "Y" &&
                  x.pas_is_rebate == "N"
                ) {
                  x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
                } else if (
                  x.pas_is_percentage === "N" &&
                  x.pas_is_rebate == "Y"
                ) {
                  //rebate does not have tax
                  x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
                } else if (
                  x.pas_is_percentage === "N" &&
                  x.pas_is_taxable === "N" &&
                  x.pas_is_rebate == "N"
                ) {
                  x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
                } else if (
                  x.pas_is_percentage === "Y" &&
                  x.pas_is_taxable === "Y" &&
                  x.pas_is_rebate == "N"
                ) {
                  x.cinemacharges = parseFloat(
                    (x.pas_charge_value *
                      this.GroupedAddonsArray[groupIndex][1][chargeIndex]
                        .net_price) /
                    100
                  ).toFixed(3);
                } else if (
                  x.pas_is_percentage === "Y" &&
                  x.pas_is_rebate == "Y"
                ) {
                  //rebate does not have tax
                  x.cinemacharges = parseFloat(
                    (x.pas_charge_value *
                      this.GroupedAddonsArray[groupIndex][1][chargeIndex]
                        .net_price) /
                    100
                  ).toFixed(3);
                } else if (
                  x.pas_is_percentage === "Y" &&
                  x.pas_is_taxable === "N" &&
                  x.pas_is_rebate == "N"
                ) {
                  x.cinemacharges = parseFloat(
                    (x.pas_charge_value *
                      this.GroupedAddonsArray[groupIndex][1][chargeIndex]
                        .net_price) /
                    100
                  ).toFixed(3);
                }
                this.GroupedAddonsArray[groupIndex][1][
                  chargeIndex
                ].charge_type_array_addons[index].cinemacharges = x.cinemacharges;
              }
            );
          }
        }
      }
    },
    getCinemaCharges: function(id, charge_setting, groupIndex, chargeIndex) {
      this.GroupedAddonsArray[groupIndex][1][
        chargeIndex
      ].charge_type_array_addons = [];
      this.GroupedAddonsArray[groupIndex][1][chargeIndex].ct_array = [];
      let payload = {
        pas_charge_setting_name: charge_setting,
        id: id
      };
      CinemasService.GetCinemaChargesByCinemaId(payload)
        .then(async response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.GroupedAddonsArray[groupIndex][1][
              chargeIndex
            ].ct_array = _.cloneDeep(data.Records);

            let promises = this.GroupedAddonsArray[groupIndex][1][
              chargeIndex
            ].ct_array.map(x => {
              x["cinemacharges"] = 0;
              let obj = {
                charge_name: x.ct_name,
                cinemacharges: x.cinemacharges,
                charge_value: x.pas_charge_value,
                ct_id: x.ct_id,
                pas_id: x.pas_id,
                pas_is_percentage: x.pas_is_percentage
              };
              return obj;
            });

            this.GroupedAddonsArray[groupIndex][1][
              chargeIndex
            ].charge_type_array_addons = promises;
            if (
              this.GroupedAddonsArray[groupIndex][1][chargeIndex].add_ons_price
            ) {
              this.cinemaChargesCalculation(groupIndex, chargeIndex);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemasList: function() {
      this.Cinemas = [];
      MasterService.GetCinemas()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;

            let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
            if (CinemaObj) {
              this.onSelectCinema(CinemaObj);
            }
          } else {
            this.$toasted.show(data.message);
            console.log("show error :", data.message);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        });
    }
  }
};
</script>
<style>
.section-collapse-box {
  border: 1px solid var(--lightgrey);
  border-radius: 10px;
  padding: 10px;
}

.right_align_absolute {
  right: -40px;
  position: absolute;
}
.borderDivider {
  border-bottom: 1px solid #9c9696;
}
.borderDivider:last-child {
  border-bottom: none;
}
.borderDivider:nth-child(even) {
  background: rgb(211 211 211 / 17%);
}
.borderChange {
  border: 1px dotted green;
}

.section-new .section-title {
  font-size: 22px;
}

.br-10 {
  border-radius: 10px;
}

.moreSettingsLink {
  color: rgb(5, 104, 197) !important;
  text-decoration: underline !important;
  cursor: pointer;
}
.new-border {
  border: 2px solid #b1b4b8;
}
label {
  color: black !important;
}
.internal-border-new {
  border: 1px solid #3876d2;
  /*background-color: #e6e6f8;*/
}
.internal-border {
  border: 1px solid #3876d2;
  background-color: #e6e6f8;
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  margin: 0 15px 15px 15px;
  padding-top: 15px;
}
.fs {
  font-size: 17px;
}
.back {
  background-color: #f5f5f5;
}
.mar {
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/AddonCharges/addonCharges.vue